import React from 'react'
import translations from './translations'

translations.add('pt', {
    paymentTimedOut: 'O seu pagamento expirou. Tente novamente.',
    close: 'Fechar'
})
